import React, { useRef, useState } from "react";
import "./getquote.css";
import { FaFacebookF, FaInstagram, FaTiktok } from "react-icons/fa";
import emailjs from "emailjs-com";

function GetAQuote() {
  const form = useRef();
  const [status, setStatus] = useState("");

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_78mpgog", // replace with your EmailJS service ID
        "template_6lozwug", // replace with your EmailJS template ID
        form.current,
        "d8qBv8wcZq-NmjhSr" // replace with your EmailJS public key
      )
      .then(
        (result) => {
          console.log(result.text);
          setStatus("Message sent successfully!");
          e.target.reset(); // reset form
        },
        (error) => {
          console.log(error.text);
          setStatus("Failed to send message. Please try again.");
        }
      );
  };

  return (
    <>
      {/* Contact Form Section */}
      <section className="get-a-quote-section">
        {/* Hero Section */}
        <div className="quote-hero">
          <div className="quote-hero-content">
            <h1>Get A Quote</h1>
            <br />
            <br />
          </div>
        </div>

        {/* Main Section */}
        <div className="quote-wrapper">
          <div className="quote-box">
            {/* Left Form */}
            <div className="quote-form">
              <p className="quote-text">
                Contact the premium aluminium products and solutions provider
                for more information or to get their unparalleled services.
                Experience the difference with{" "}
                <b>Innovative Pre Fab Technology</b>, where precision meets
                perfection.
              </p>

              <form ref={form} onSubmit={sendEmail}>
                <input type="text" name="user_name" placeholder="Your Name *" required />
                <input type="email" name="user_email" placeholder="Your E-mail *" required />

                <div className="row">
                  <input type="text" name="user_phone" placeholder="Your Phone Number *" required />
                  <input type="text" name="user_location" placeholder="Your Location" />
                </div>

                <textarea name="message" placeholder="Your Message" rows="5"></textarea>

                <button type="submit">SEND MESSAGE</button>
              </form>

              {status && <p className="form-status">{status}</p>}
            </div>

            {/* Right Info */}
            <div className="quote-info">
              <a href="/Company Profile - IPFT.pdf" className="brochure-btn" download>
                📄 COMPANY BROCHURE
              </a>

              <h3>Contact Info</h3>

              <div className="info-item">
                <span>EMAIL</span>
                <p>info@innovativeprefab.lk</p>
              </div>

              <div className="info-item">
                <span>PHONE NUMBER</span>
                <p>+94 77 732 4632</p>
                <p>+94 71 956 6805</p>
              </div>

              <div className="info-item">
                <span>LOCATION</span>
                <p>No: 318/1, Colombo Road, Bokundara, Piliyandala, Sri Lanka</p>
              </div>

              <div className="socials">
                <FaFacebookF />
                <FaInstagram />
                <FaTiktok />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Work With Us Section */}
      <section className="elementor-section elementor-top-section elementor-element elementor-element-d28a840 e-flex e-con-boxed e-con e-parent" data-id="d28a840" data-element_type="container">
        <div className="e-con-inner">
          <div className="elementor-element elementor-element-e58d206 elementor-widget elementor-widget-heading" data-id="e58d206" data-element_type="widget">
            <div className="elementor-widget-container">
              <h2 className="elementor-heading-title elementor-size-default">Work with Us</h2>
            </div>
          </div>

          <div className="elementor-element elementor-element-0a0cc28 elementor-widget elementor-widget-heading" data-id="0a0cc28" data-element_type="widget">
            <div className="elementor-widget-container">
              <p className="elementor-heading-title elementor-size-default">
                Ready to elevate your project with our premium Pre-Fab solutions? Click below to get a personalized quote and see how Innovative Pre Fab Technology can bring your vision to life efficiently.
              </p>
            </div>
          </div>

          <div className="elementor-element elementor-element-5e7e540 elementor-align-center elementor-widget elementor-widget-button" data-id="5e7e540" data-element_type="widget">
            <div className="elementor-widget-container">
              <div className="elementor-button-wrapper">
                <a className="elementor-button elementor-button-link elementor-size-sm" href="/contactus/">
                  <span className="elementor-button-content-wrapper">
                    <span className="elementor-button-text">Contact Us</span>
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default GetAQuote;
